















































import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import { ModelState } from "@elite/validation";
import { RestClient } from "@elite/restclient";
import { HomeRoute } from "../router";
import { IForgotPasswordModel } from "@/models";
import IView from "./IView";

@Component
export default class ForgotPassword extends Vue implements IView {
    @Inject()
    restClient!: RestClient;
    @Inject()
    modelState!: ModelState;

    @Prop({ required: true })
    title!: string;

    model: IForgotPasswordModel = { emailAddress: "" };

    loading = false;
    error: string | null = null;
    success = false;

    async forgotPassword(): Promise<void> {
        this.modelState.clear(this);
        this.loading = true;

        const response = await this.restClient.postJson(
            "/api/ForgotPassword",
            this.model
        );

        this.loading = false;

        if (this.modelState.hasErrors(response)) {
            this.modelState.addResponseErrors(response, this);
            return;
        }

        this.success = true;
    }

    async cancel(): Promise<void> {
        if (this.$route.path !== HomeRoute.path) {
            await this.$router.push(HomeRoute.path);
        }
    }
}
